"use client";

import Introduction from "./content/introduction.mdx";

export default function DocsClient() {
  return (
    <div className="prose prose-indigo max-w-none">
      <Introduction />
    </div>
  );
}
